// import React from 'react';
// import { Link } from 'react-router-dom';
// import { 
//   PlusCircle, 
//   Users, 
//   Combine, 
//   KeyRound, 
//   Bell, 
//   MessageSquare, 
//   ArrowRight,
//   Wallet  ,
//   FolderTree
// } from 'lucide-react';
// import { hasPermission, ROLES } from '../../utils/rbacHelper';
// import './QuickActions.css';

// function QuickActions({ 
//   currentUserRole, 
//   setShowAddDeviceModal, 
//   setShowCreateUserModal, 
//   setShowAddAssetModal ,
//   setShowCreateCustomerModal,  
//   setShowCreateDealerModal ,
// }) {
//   const can = (action) => hasPermission(currentUserRole, action);

//   const ActionContent = ({ icon: Icon, label }) => (
//     <>
//       <div className="qa-icon-box">
//         <Icon size={20} />
//       </div>
//       <div className="qa-text-group">
//         <span className="qa-label">{label}</span>
//       </div>
//       <div className="qa-arrow">
//         <ArrowRight size={16} />
//       </div>
//     </>
//   );

//   return (
//     <section className="qa-container">
//       <div className="qa-header">
//         <h2 className="qa-title">Quick Actions</h2>
//         <p className="qa-subtitle">Shortcuts for common tasks</p>
//       </div>
      
//       <div className="qa-grid">
        
//         {/* ✅ Add Device */}
//         {can('createDevice') && (
//           <button className="qa-card-btn" onClick={() => setShowAddDeviceModal(true)}>
//             <ActionContent icon={PlusCircle} label="Add Device" />
//           </button>
//         )}

//         {/* ✅ Create Dealers - sub_admin & group_admin ONLY */}
//         {['sub_admin', 'group_admin'].includes(currentUserRole) && (
//           <button className="qa-card-btn" onClick={() => setShowCreateDealerModal(true)}>
//             <ActionContent icon={Users} label="Create Dealers" />
//           </button>
//         )}

//         {/* ✅ Create Clients - sub_admin & group_admin ONLY */}
//         {['sub_admin', 'group_admin'].includes(currentUserRole) && (
//           <button className="qa-card-btn" onClick={() => setShowCreateCustomerModal(true)}>
//             <ActionContent icon={Users} label="Create Client" />
//           </button>
//         )}

//         {/* ✅ Add Assets */}
//         {can('createAsset') && (
//           <button className="qa-card-btn" onClick={() => setShowAddAssetModal(true)}>
//             <ActionContent icon={Combine} label="Add Assets" />
//           </button>
//         )}

//      {/* ✅ Manage Groups (ALL roles except viewer) */}
// {[
//   'admin',
//   'manager',
//   'hr',
//   'office_emp',
//   'field_emp',
//   'sub_admin',
//   'group_admin',
//   'client',
//   'user',
// ].includes(role) && (
//   <Link to="/groups" className="qa-card-btn">
//     <ActionContent icon={FolderTree} label="Manage Groups" />
//   </Link>
// )}

//         {/* ✅ Protocols */}
//         {can('viewProtocols') && (
//           <Link to="/protocols" className="qa-card-btn">
//             <ActionContent icon={KeyRound} label="Protocols" />
//           </Link>
//         )}

//         {/* ✅ View Alerts */}
//         {currentUserRole !== ROLES.FIELD_EMPLOYEE && (
//           <button className="qa-card-btn" onClick={() => console.log('View Alerts')}>
//             <ActionContent icon={Bell} label="View Alerts" />
//           </button>
//         )}

//         {/* ✅ FIXED: Manage Credits - Admin (Super Admin) & Manager */}
//         {/* Logic: Donon roles ko array mein daal kar check karna sabse safe hai */}
//         {['admin', ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.DEALER, ROLES.SUB_ADMIN].includes(currentUserRole) && (
//           <Link to="/credits" className="qa-card-btn">
//             <ActionContent icon={Wallet} label="Manage Credits" />
//           </Link>
//         )}

//         {/* ✅ Messages */}
//         {['admin', ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN].includes(currentUserRole) && (
//           <Link to="/message" className="qa-card-btn">
//             <ActionContent icon={MessageSquare} label="Messages" />
//           </Link>
//         )}

//       </div>
//     </section>
//   );
// }

// export default QuickActions;
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Paper,
  Typography,
  Stack,
  useTheme,
} from '@mui/material';
import {
  PlusCircle,
  Users,
  Combine,
  KeyRound,
  MessageSquare,
  ArrowRight,
} from 'lucide-react';

import { hasUserPermission } from '../../utils/rbacHelper';

function QuickActions({
  currentUser,
  setShowAddDeviceModal,
  setShowCreateUserModal,
  setShowAddAssetModal,
}) {
  const theme = useTheme();
  const can = (action) => hasUserPermission(currentUser, action);
  const currentRole = String(currentUser?.role || "").trim().toLowerCase();
  const isScopedMessagingRole = currentRole === "sub_admin" || currentRole === "group_admin" || currentRole === "dealer";

  const ActionCard = ({ icon: Icon, label, onClick, to }) => {
    const card = (
      <Paper
        elevation={0}
        onClick={onClick}
        sx={{
          minWidth: 240,              // 🔥 KEY POINT
          p: 2,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          cursor: 'pointer',
          flexShrink: 0,              // 🔥 Prevent wrapping
          transition: '0.2s',
          '&:hover': {
            borderColor: 'primary.main',
            boxShadow: theme.shadows[2],
          },
        }}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: 1.5,
              border: '1px solid',
              borderColor: 'divider',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'primary.main',
            }}
          >
            <Icon size={20} />
          </Box>

          <Typography fontWeight={600} flexGrow={1}>
            {label}
          </Typography>

          <ArrowRight size={18} />
        </Stack>
      </Paper>
    );

    if (to) {
      return (
        <Box
          component={RouterLink}
          to={to}
          sx={{ textDecoration: 'none', color: 'inherit' }}
        >
          {card}
        </Box>
      );
    }

    return card;
  };

  return (
    <Box>
      {/* Header */}
      <Box mb={2}>
        <Typography variant="h6" fontWeight={700}>
          Quick Actions
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Shortcuts for common tasks
        </Typography>
      </Box>

      {/* 🔥 ROW EVERYWHERE */}
      <Stack
        direction="row"
        spacing={2}
        sx={{
          overflowX: 'auto',
          pb: 1,
          '&::-webkit-scrollbar': { height: 6 },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.divider,
            borderRadius: 4,
          },
        }}
      >
        {can('createDevice') && (
          <ActionCard
            icon={PlusCircle}
            label="Add Device"
            onClick={() => setShowAddDeviceModal(true)}
          />
        )}

        {can('createUser') && setShowCreateUserModal && (
          <ActionCard
            icon={Users}
            label="Create User"
            onClick={() => setShowCreateUserModal(true)}
          />
        )}

        {can('createAsset') && (
          <ActionCard
            icon={Combine}
            label="Add Assets"
            onClick={() => setShowAddAssetModal(true)}
          />
        )}

        {can('viewProtocols') && !isScopedMessagingRole && (
          <ActionCard
            icon={KeyRound}
            label="Protocols"
            to="/protocols"
          />
        )}

        {can('messageManagement') && (
          <ActionCard
            icon={MessageSquare}
            label="Messages"
            to="/message"
          />
        )}
      </Stack>
    </Box>
  );
}

export default QuickActions;
